import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ArticleDetailView from '../components/ArticleDetailView';
import { AUTH_CONFIG } from '../config';

const ArticleDetail = () => {
  const { id } = useParams();
  const [isAdmin, setIsAdmin] = useState(false);
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [notAuthorized, setNotAuthorized] = useState(false);
  
  // Check if user is authenticated as admin
  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        const authenticated = await AUTH_CONFIG.isAuthenticated();
        setIsAdmin(authenticated);
      } catch (error) {
        console.error('Error checking authentication:', error);
        setIsAdmin(false);
      }
    };
    
    checkAdminStatus();
  }, []);
  
  // Fetch article to check if it's viewable
  useEffect(() => {
    const fetchArticle = async () => {
      try {
        setLoading(true);
        const response = await fetch(`/api/articles/${id}`);
        
        if (!response.ok) {
          if (response.status === 404) {
            setNotFound(true);
          }
          return;
        }
        
        const data = await response.json();
        const articleData = data.article || {};
        
        // Only show published articles to non-admin users
        if (articleData.status !== 'Published' && !isAdmin) {
          console.log(`Access blocked for article with status: ${articleData.status}`);
          setNotAuthorized(true);
          return;
        }
        
        console.log(`Access granted for article with status: ${articleData.status} (isAdmin: ${isAdmin})`);
        
        setArticle(articleData);
      } catch (error) {
        console.error('Error fetching article:', error);
      } finally {
        setLoading(false);
      }
    };
    
    if (id) {
      fetchArticle();
    }
  }, [id, isAdmin]);
  
  // Redirect if not found or not authorized
  if (notFound) {
    return <Navigate to="/a" replace />;
  }
  
  if (notAuthorized) {
    return <Navigate to="/a" replace />;
  }
  
  // Show loading state
  if (loading && !article) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-pulse">Loading article...</div>
      </div>
    );
  }
  
  return <ArticleDetailView isAdmin={isAdmin} />;
};

export default ArticleDetail;